import { API_SPECIFICATION } from "../constants/index";
import axios from "axios";

import _ from "lodash";

export const getAPIPrefix = (version = API_SPECIFICATION) => {
  return `/api/v${version}`;
};

export function data_fetch_api_resource(
  token,
  resource,
  version = API_SPECIFICATION
) {
  return axios.get(getAPIPrefix(version) + "/" + resource)
}

export function data_fetch_api_resource_with_params(
  token,
  resource,
  params = {},
  version = API_SPECIFICATION
) {
  return axios
    .get(getAPIPrefix(version) + "/" + resource, {
      params,
    })
}

export function data_download_api_resource(
  token,
  resource,
  version = API_SPECIFICATION
) {
  return axios.get(getAPIPrefix(version) + "/" + resource, {
    responseType: "blob",
  })
}

export function data_download_api_resource_with_params(
  token,
  resource,
  version = API_SPECIFICATION,
  params = {}
) {
  return axios.get(getAPIPrefix(version) + "/" + resource, {
    responseType: "blob",
    params: params
  })
}

export function data_download_api_resource_with_body(token, resource, version = API_SPECIFICATION, body = {}) {
  return axios.post(
    getAPIPrefix(version) + "/" + resource,
    body,
    {
      responseType: "blob",
    }
  );
}

export const data_create_api_resource = async (
  token,
  resource,
  new_data,
  version = API_SPECIFICATION
) => {
  return axios.post(
    getAPIPrefix(version) + "/" + resource,
    new_data
  );
};

export function data_update_api_resource(
  token,
  resource,
  new_data,
  version = API_SPECIFICATION
) {
  return axios.put(
    getAPIPrefix(version) + "/" + resource,
    new_data
  );
}

export function data_delete_api_resource(
  token,
  resource,
  version = API_SPECIFICATION
) {
  return axios.delete(getAPIPrefix(version) + "/" + resource);
}